import { useCallback } from 'react';
import { TOP_NAV } from '@atlassian/jira-spa-state-controller/src/common/constants.tsx';
import { useSpaStateActions } from '@atlassian/jira-spa-state-controller/src/common/index.tsx';

export const useAtlassianNavigationEnd = () => {
	const { setAppReadyWithAppId } = useSpaStateActions();
	return useCallback(() => {
		setAppReadyWithAppId(TOP_NAV);
	}, [setAppReadyWithAppId]);
};
